export const SET_EDITOR_LINK_TARGET_TYPE = 'SET_EDITOR_LINK_TARGET_TYPE'
